// extracted by mini-css-extract-plugin
module.exports = {"title":"title-module--title--S6qbF","titleText":"title-module--title-text--ZiAfE"};